import { userApiService } from "./userApiService";

export function subscribeDeviceAlerts(deviceId, onData, onError, intervalMs = 60000) {
  let active = true;

  async function tick() {
    try {
      const data = await userApiService.listNotifications({
        deviceId,
        limit: 200,
      });
      if (!active) return;
      const byTimestamp = {};
      (data?.items || []).forEach((item) => {
        const ts = item.timestamp || String(item.createdAt || Date.now());
        byTimestamp[ts] = {
          type: item.type,
          metric: item.metric,
          value: item.value,
          message: item.message,
          source: item.source,
        };
      });
      onData(byTimestamp);
    } catch (error) {
      if (onError) onError(error);
    }
  }

  tick();
  const timer = setInterval(tick, intervalMs);
  return () => {
    active = false;
    clearInterval(timer);
  };
}

